var _circle, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKeyboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#1DB469"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.25 34.2087H18.75C17.875 34.2087 17.2333 34.1737 16.685 34.092C12.8116 33.672 12.0416 31.3503 12.0416 27.5003V20.5003C12.0416 16.6503 12.8116 14.3287 16.72 13.897C17.2333 13.827 17.875 13.792 18.75 13.792H29.25C30.125 13.792 30.7666 13.827 31.315 13.9087C35.1883 14.3287 35.9583 16.6503 35.9583 20.5003V27.5003C35.9583 31.3503 35.1883 33.672 31.28 34.1037C30.7666 34.1737 30.125 34.2087 29.25 34.2087ZM18.75 15.542C17.9566 15.542 17.3966 15.577 16.9416 15.6353C14.5733 15.9037 13.7916 16.6387 13.7916 20.5003V27.5003C13.7916 31.362 14.5733 32.097 16.9066 32.3653C17.3966 32.4353 17.9566 32.4587 18.75 32.4587H29.25C30.0433 32.4587 30.6033 32.4237 31.0583 32.3653C33.4266 32.1087 34.2083 31.362 34.2083 27.5003V20.5003C34.2083 16.6387 33.4266 15.9037 31.0933 15.6353C30.6033 15.5653 30.0433 15.542 29.25 15.542H18.75Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8333 22.542H25.75C25.2717 22.542 24.875 22.1453 24.875 21.667C24.875 21.1887 25.2717 20.792 25.75 20.792H29.8333C30.3117 20.792 30.7083 21.1887 30.7083 21.667C30.7083 22.1453 30.3117 22.542 29.8333 22.542Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7829 22.8333C21.1412 22.8333 20.6162 22.3083 20.6162 21.6667C20.6162 21.025 21.1295 20.5 21.7829 20.5H21.7945C22.4362 20.5 22.9612 21.025 22.9612 21.6667C22.9612 22.3083 22.4362 22.8333 21.7829 22.8333Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2829 22.8333C17.6412 22.8333 17.1162 22.3083 17.1162 21.6667C17.1162 21.025 17.6295 20.5 18.2829 20.5C18.9245 20.5 19.4495 21.025 19.4495 21.6667C19.4495 22.3083 18.9362 22.8333 18.2829 22.8333Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8331 28.958H18.1898C17.7114 28.958 17.3031 28.5613 17.3031 28.083C17.3031 27.6047 17.6881 27.208 18.1664 27.208H29.8331C30.3115 27.208 30.7081 27.6047 30.7081 28.083C30.7081 28.5613 30.3115 28.958 29.8331 28.958Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboard);
export default __webpack_public_path__ + "static/media/keyboard.6b8460f41466876310794b66cc6bc658.svg";
export { ForwardRef as ReactComponent };